import React, { useEffect, useRef, useState } from "react";
import { Formik, Field } from "formik";
import CustomComponent from "./CustomComponent";
import { Button, Form, Progress, Spin, Typography, Checkbox } from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import { onecodeAPI } from "../AppConfig";
import mixpanel from "mixpanel-browser";

let otpVerifyClick = false;
let prevOtp = "";
const DynamicForm = ({
    formValidations,
    data,
    fullData,
    activeStep,
    saveStepData,
    stepCount,
    hash,
    preFormValues,
    formValues,
    setShowModal,
    phoneNumber,
    dateFormat,
    partner,
    pageTitle,
    }) => {
      const { Text } = Typography;
      

      const [showText, setShowText] = React.useState(false);

  const Ref = useRef(null);
  const [timer, setTimer] = useState('00:00:00');


  const getTimeRemaining = (e) => {
      const total = Date.parse(e) - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / 1000 / 60 / 60) % 24);
      return {
          total, hours, minutes, seconds
      };
  }

  const startTimer = (e) => {
      let { total, hours, minutes, seconds } 
                  = getTimeRemaining(e);
      if (total >= 0) {
          setTimer(
              (hours > 9 ? hours : '0' + hours) + ':' +
              (minutes > 9 ? minutes : '0' + minutes) + ':'
              + (seconds > 9 ? seconds : '0' + seconds)
          )
      }
  }

  const clearTimer = (e) => {  
      setTimer('00:00:20');
      if (Ref.current) clearInterval(Ref.current);
      const id = setInterval(() => {
          startTimer(e);
      }, 1000)
      Ref.current = id;
  }

  const getDeadTime = () => {
      let deadline = new Date();
      deadline.setSeconds(deadline.getSeconds() + 20);
      return deadline;
  }

  useEffect(() => {
    const getData = setTimeout(() => {
      setShowText(false);
    }, 20000);
    clearTimer(getDeadTime());
  }, []);



      const antIcon = (
        <LoadingOutlined
          style={{ fontSize: 18, color: "#fff", marginRight: 10 }}
          spin
        />
      );
      const [form] = Form.useForm();
      const [formSubmitLoading, setFormSubmitLoading] = useState(false);
      const [isOtpVerified, setIsOtpVerified] = useState((partner?.id === 207 || partner?.id === 219) ? null : true);
      const [sentOtp, setSentOtp] = useState(false);

      const onSubmit = async (value) => {
        saveStepData(value,activeStep);
      };

      const verifyOtp = async (otpCode,OtpFormValues,errors) => { 
        if(!otpVerifyClick && otpCode.length === 4 && prevOtp !== otpCode ) {
          setIsOtpVerified(null);
          prevOtp = otpCode;
          otpVerifyClick = true;
        const filterData =  data.filter((formItem) => formItem.code === "mobileNumber" || formItem.code === "MobileNumber");
        if(filterData && filterData.length > 0) {

          if(!errors[filterData[0].id]) {
            let mobileNumber = OtpFormValues[filterData[0].id];
            let firstName = ""
            Object.keys(fullData).map(function (key) {
              fullData[key].map((item) => {
                if (item.code === "firstName" || item.code === "Name") {
                  firstName = formValues[key][item.id];
                }
              });
            });
            const apiData = {
              "firstName": firstName,
              "phoneNumber": mobileNumber,
                "otp":otpCode,
                "hash":hash,
            }
            try {
              const response = await onecodeAPI.post(`/public/verifyOtpForApiIntegration`,apiData);
              if(response.data.type === "success") {
                setIsOtpVerified(true);
              } else {
                setIsOtpVerified(false);
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
        otpVerifyClick = false;
      }
      prevOtp = otpCode;
      };

      const ErrorComponent = ({ message }) => {
        return (
          <p
            style={{
              color: "red",
              fontSize: 12,
              textAlign: "left",
              position: "relative",
              marginTop: 1,
              marginBottom: 10,
              lineHeight: 1,
              paddingLeft: 2,
            }}
          >
            {message}
          </p>
        );
      };

      const ButtonText = () => {
        if(sentOtp && !showText && timer === '00:00:00') {
          return `Resend OTP`
        }
        else if(showText && timer === '00:00:00') {
          return `Resend OTP`
        }
        else if(showText) {
          return `Resend in ${timer}`
        }
        else {
          return 'Send OTP'
        }
      }

      const ButtonDisable = (values) => {

        let phoneNumber = "";
              Object.keys(fullData).map(function (key) {
                fullData[key].map((item) => {
                  if (item.code === "mobileNumber" || item.code === "MobileNumber") {
                    phoneNumber = values[item.id];
                  }
                });
              });

        if(phoneNumber?.length !== 10)
        {
          return true
        }
        else if(sentOtp && showText && timer !== '00:00:00') {
          return true
        }
        else if(showText) {
          return false
        }
        else {
          return false
        }
      }

 const openPdf=()=>{
  window.open('https://drive.google.com/file/d/14FQK85xUbpabUjHjdQOGEuNS993-e1Vm/view',"_blank")
 }

      return ( 
        <Formik
          initialValues={{ ...formValues[activeStep] }}
          validationSchema={formValidations[activeStep]}
          onSubmit={onSubmit}
          validateOnBlur={true}
          validateOnChange={true}
          validateOnMount={true}
          enableReinitialize
        >
          {(formikData) => {
            const {
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              isValid,
              touched,
              setValues,
              setTouched,
              resetForm,
              setFieldValue,
              dirty,
            } = formikData;

            const otpcode = async (code) => {
              setSentOtp(false)
              let firstName = "";
              let phoneNumber = "";
              Object.keys(fullData).map(function (key) {
                fullData[key].map((item) => {
                  if (item.code === "firstName" || item.code === "Name") {
                    firstName = formValues[key][item.id];
                  }
                  if (item.code === "mobileNumber" || item.code === "MobileNumber") {
                    phoneNumber = values[item.id];
                  }
                  if(item.code === "otp"){
                    setFieldValue(item.id, "")
                  }
                });
              });

              const apiData = {
                "firstName": firstName,
                 "phoneNumber": phoneNumber,
                  "hash":hash,
            };
              const sendOtp = await onecodeAPI.post(`/public/sendOtpForApiIntegration`,apiData);
              setSentOtp(true)
            };
    
            return (
              <Form
                form={form}
                name="control-hooks"
                style={{  height: "100%",display: "flex",flexDirection: "column",justifyContent:"space-between"}}
                initialValues={{ ...formValues[activeStep]}}
              >
                <div 
                style={{
                      margin: 16,
                      padding: 5,
                    }}
                >
                {data &&
                  data.map((formItem,index) => {
                    const id = `${formItem.id}`;
                    const marginBottom = touched[id] && errors[id] ? 0 : 20;

                    if(formItem.code == "otp" && values[id]) {
                      verifyOtp(values[id],values,errors);
                    }

                    let addManualField = false;
                    let manualFieldData = {};

                    if (formItem.code == "companyName") {
                      const dependedField = data.filter(
                        (fi) => fi.code == "companyName"
                      );
                      if (dependedField && dependedField.length > 0) {
                        if (values[`${dependedField[0].id}`] && values[`${dependedField[0].id}`].toLowerCase() == "c") {
                          addManualField = true;
                          manualFieldData = {
                            name: "Other Company Name",
                            code: "manualOtherCompanyName",
                            id: "manualOtherCompanyName",
                            type: "text",
                          };
                        }
                      }
                    }
    
                    let showOtpButton = false;

                    if(formItem.code === "mobileNumber" || formItem.code === "MobileNumber") {
                      showOtpButton  = true;
                    }
                    
                    
                    return (
                      <React.Fragment key={id}>
                      <div  style={{ marginBottom: marginBottom }}>
                        <div style={{ position: "relative" }}>
                          <CustomComponent
                            formItem={formItem}
                            id={id}
                            formData={data}
                            hash={hash}
                            values={values}
                            preFormValues={preFormValues}
                            errors={errors}
                            phoneNumber={phoneNumber}
                            fullData={fullData}
                            formValues={formValues}
                            dateFormat={dateFormat}
                            autoFoucs={index == 0}
                            partner={partner}
                            isOtpVerified={isOtpVerified && !errors[id] ? true : false}
                          />
                          {(touched[id] || values[id]) && errors[id] ? (
                            <ErrorComponent message={errors[id]} />
                          ) : formItem.code == "otp" && isOtpVerified == false && values[id] ? 
                            <ErrorComponent message={"Enter Valid OTP"} />  
                          : null}

                          { showOtpButton ?
                          <div>
                            <Button
                              type="link"
                              onClick={() => { 
                                otpcode(formItem.code)
                                setShowText(true)
                                clearTimer(getDeadTime())
                                mixpanel.track( "click_action", {
                                  item_name: partner?.id === 207 ? "sbi_form_resendotp" : "bajaj_form_resendotp",
                                  partner_id: partner?.id,
                                  phone_number: phoneNumber
                                });
                              } 
                              }
                              style={{borderWidth: 0,}}
                              disabled={ButtonDisable(values)}
                              >
                              {ButtonText()}
                            </Button>
                          </div>
                          : null
                        }

                        </div>
                      </div>
                      {addManualField ? (
                        <div style={{ marginBottom: marginBottom }}>
                          <div style={{ position: "relative" }}>
                            <CustomComponent
                              formItem={manualFieldData}
                              id={manualFieldData.id}
                              formData={data}
                              hash={hash}
                              values={values}
                              preFormValues={preFormValues}
                              errors={errors}
                              isOtpVerified={isOtpVerified}
                            />
                            {(touched[manualFieldData.id]) &&
                              errors[manualFieldData.id] && (
                                <ErrorComponent
                                  message={errors[manualFieldData.id]}
                                />
                              )}
                          </div>
                        </div>
                      ) : null}
                      </React.Fragment>
                    );
                  })}
                </div>
                <div style={{ 
                    // bottom: 0,
                    // position: "fixed",
                    width:  "100%",
                    // display: "flex",
                    // justifyContent: "space-between",
                    // flexDirection: "column",
                }}
                >
                <div>
                { stepCount === 0 && (partner?.id === 207 || partner?.id === 219) ?
                <div style={{display: "flex",margin: 16, width: "90%",flexDirection: "row",alignItems: "start"}}>
                  <Checkbox defaultChecked={true}/>
                  {partner?.id === 207 && <div style={{marginLeft: 4,color: "#787878",fontSize: 12}}>I have read <span onClick={()=> setShowModal(true)} style={{color: "#6C63FF",textDecoration:"underline"}}>Customer Declaration</span> of SBI Card & understood all its terms and conditions. I conﬁrm that details given above belong to me and authorize SBICPSL & its aﬃliates or associates to contact me on the details provided.
                  </div>}
                  {partner?.id === 219 && <div style={{marginLeft: 4,color: "#787878",fontSize: 12}}>By clicking Submit, you are agreeing to the <span onClick={openPdf} style={{color: "#6C63FF",textDecoration:"underline"}}>Terms & Conditions</span> of Vistas Technolabs Pvt Ltd and Bajaj Finserv RBL Bank Credit Card.
                  </div>}
                </div>
                : null
                }
                </div>
                <div 
                style={{boxShadow: "0px 0.5px 8px 2px rgba(0, 0, 0, 0.05)",
                    padding : "8px",
                    paddingBottom: "16px",
                    display: "flex",
                    width:  "100%",
                    justifyContent: "space-between",
                    }}>
                <div style={{ width: "30%"}}>
                <Progress
                    strokeColor={{
                        from: '#108ee9',
                        to: '#87d068',
                    }}
                    showInfo={false}
                    percent= {data && Math.round(100/Object.keys(fullData).length)*(Object.keys(fullData).length-stepCount - 1)}
                />
                {stepCount == 0 ? "Final step" : `${stepCount} steps left` }
                </div>
                <div 
                style = {{width: "40%",}}
                >
                <Button
                  disabled={stepCount == 0 ?  !isValid && isOtpVerified  : !isValid}
                  type="primary"
                  block
                  style={{
                    backgroundColor: stepCount == 0 ?  isValid && isOtpVerified  ? "#6C63FF" : "#d9d9d9" : isValid ? "#6C63FF" : "#d9d9d9",
                    borderRadius: 6,
                    height: 40,
                    borderColor: stepCount == 0 ?  isValid && isOtpVerified  ? "#6C63FF" : "#d9d9d9" : isValid ? "#6C63FF" : "#d9d9d9",
                    fontWeight: "bold",
                    fontSize: 16,
                    marginTop: "4px"
                  }}
                  onClick={() => {
                    const getData = setTimeout(() => {
                      if (isValid && stepCount > -1) {
                        // stepCount == 0 && verifyOtp();
                       
                        if(stepCount == 0 ) {
                          if(isOtpVerified) {
                            handleSubmit();
                          }
                        } else {
                          handleSubmit();
                        }
                      }
                    }, 100);
                    mixpanel.track( "click_action", {
                      item_name: stepCount === 0 ? ( partner?.id === 219 ? "bajaj_form_submit" : "sbi_form_submit" ) : ( partner?.id === 219 ? "bajaj_form_next" : "sbi_form_next"),
                      page_name: pageTitle,
                      partner_id : partner?.id,
                      phone_number: phoneNumber
                    });
                    
                  }}
                >
                  {formSubmitLoading && <Spin indicator={antIcon} />}
                  <Text style={{ color: "#fff" }}> {stepCount == 0 ? "Submit" : "Next" } </Text>
                </Button>
                </div>
                </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      );
    };
  

    export default DynamicForm;